<fin-ancillary-campaign (ctaClick)="openAncillarySubviewFromCampaign($event)"></fin-ancillary-campaign>

<div class="pr-medium-b">
  <fin-product-list
    [products$]="products$"
    [purchaseFlow]="purchaseFlow"
    [tabletShowTwoPerRow]="true"
    [hideZeroPrices]="true"
    (viewDetails)="viewDetails($event)"
    [focusOnProductBtn$]="focusOnProductBtn$"
    [focusOnViewDetails$]="viewDetailsClosed$"
    [productCardLocalizationsPrefix]="'MMB.'"
    [bounds$]="[] | finToObservable"
    (selectProduct)="openAncillarySubview($event)"
  ></fin-product-list>
</div>

<fin-ancillary-subview
  *ngIf="order$ | async as booking"
  #ancillarySubview
  [hideSideBar]="true"
  [showFlightCard$]="ancillarySubviewOpen$"
  [onlyShowAncillaries]="true"
  [cartOrOrder$]="order$"
  [cartTotalPrice$]="totalPrice$"
  [boundsOrFlights]="boundsOrFlights$ | async"
  [locations]="booking.locations"
  [category]="selectedCategory$ | async"
  [titleKey]="buttonText[selectedCategory$ | async]?.title"
  [subviewName]="'subview-' + (selectedCategory$ | async)"
  [unpaidServices$]="unpaidServices$"
  [subtitleMessageKey$]="subtitleMessageKey$"
  [currentIncludedServices]="currentIncludedServices$ | async"
  [purchasedServices$]="purchasedServices$"
  [subviewContext]="TRACKING_CONTEXT"
  [showFareFamilyInAncillarySidebar]="false"
  [skipEnabled]="true"
  [hideChangeButton]="true"
  [skipText]="'MMB.view.ancillaries.skipSidebarContent' | finLocalization"
  [maxedOutForFragment$]="maxedOutForFragmentId$"
  [boundOrFlightAncillaryAvailability$]="boundOrFlightAncillaryAvailability$"
  [passengersWithPetcIncompatibleSeats$]="passengersWithPetcUnpaidIncompatibleSeats$"
  (flightOrBoundSelected)="flightOrBoundSelected($event)"
  (close)="updateServices(booking, selectedCategory$.value)"
  (secondaryButtonClick)="updateServicesAndRedirect(booking, selectedCategory$.value)"
  (reassignSeats)="reassignFreeSeatsForFlight(booking, $event)"
  [confirmModalData$]="confirmModalData$"
  (closeConfirmModal)="closeConfirmModal($event)"
>
  <ng-container *ngIf="selectedCategory$ | async as currentCategory">
    <ng-container *ngIf="BOUND_BASED_CATEGORIES.includes(currentCategory); else flights">
      <div *ngFor="let bound of booking.bounds" class="inline-block valign-top fill">
        <fin-common-product-selection
          *ngIf="currentCategory !== Category.PET"
          class="flex flex--column flex--nowrap"
          [category$]="selectedCategory$"
          [serviceQuantityMap$]="serviceQuantitityMap$"
          [paxLevelQuota$]="paxLevelQuota$"
          [servicesReady$]="servicesReady$"
          [travelers$]="booking.passengers | finToObservable"
          [flightOrBound$]="bound | finToObservable"
          [services$]="currentServices$ | finMap: bound.id"
          [includedServices$]="currentIncludedServices$"
          [combinedServices$]="currentCombinedServices$"
          [availability$]="boundOrFlightAncillaryAvailability$"
          [initialSelectedTravelerId$]="initialSelectedTravelerId$"
          (subtotalChange)="ancillarySubview.setSubTotalPrice($event, currentCategory, bound.id)"
        ></fin-common-product-selection>

        <fin-common-product-selection
          *ngIf="currentCategory === Category.PET"
          class="flex flex--column flex--nowrap"
          [category$]="selectedCategory$"
          [serviceQuantityMap$]="serviceQuantitityMap$"
          [servicesReady$]="servicesReady$"
          [travelers$]="booking.passengers | finToObservable"
          [flightOrBound$]="bound | finToObservable"
          [services$]="currentServices$ | finMap: bound.id"
          [includedServices$]="includedServices$ | finMap: currentCategory"
          [combinedServices$]="currentCombinedServices$"
          [showConfirmationModalBeforeSelectionForPassengers$]="
            passengersWithPetcUnpaidIncompatibleSeats$ | finMap: bound.id
          "
          [blockSelectionNotification$]="blockSelectionNotification$ | finMap: bound.id"
          [confirmModalData$]="confirmModalData$"
          (openConfirmModalWithData)="setConfirmModalData($event, PETC_CONFIRM_MODAL_TRANSLATION_KEYS)"
          [availability$]="boundOrFlightAncillaryAvailability$"
          [initialSelectedTravelerId$]="initialSelectedTravelerId$"
          (subtotalChange)="ancillarySubview.setSubTotalPrice($event, Category.PET, bound.id)"
        ></fin-common-product-selection>
      </div>
    </ng-container>

    <ng-template #flights>
      <div *ngFor="let flight of itineraryFlights$ | async" class="inline-block valign-top fill">
        <ng-container [ngSwitch]="currentCategory">
          <ng-container *ngSwitchCase="Category.SEAT">
            <fin-ancillary-seat-map
              [flight]="flight"
              [passengers$]="booking.passengers | finToObservable"
              [cartOrOrder$]="order$"
              [seatSelections$]="seatSelections$"
              [flightIsActive$]="(selectedFlightOrBound$ | async) === flight.id | finToObservable"
              [includedSeats]="currentIncludedServices$ | async"
              [availability$]="boundOrFlightAncillaryAvailability$"
              [ancillaryLoader$]="ancillarySubview.ancillaryLoader$"
              [preSelectedPax$]="initialSelectedTravelerId$"
              [notEligibleWhenCheckInClosed]="!!(seatPurchaseNotEligibleAfterCheckInForFlight$ | async).get(flight.id)"
              (changeSeats)="changeSeats($event)"
              (retrySeatmap)="loadSeatMapForFlightFromOrder($event)"
              (subtotalChange)="ancillarySubview.setSubTotalPrice($event, Category.SEAT, flight.id)"
            >
            </fin-ancillary-seat-map>
          </ng-container>
          <fin-common-product-selection
            *ngSwitchDefault
            class="flex flex--column flex--nowrap"
            [attr.aria-hidden]="flight.id !== (selectedFlightOrBound$ | async)"
            [category$]="selectedCategory$"
            [servicesReady$]="servicesReady$"
            [travelers$]="booking.passengers | finToObservable"
            [flightOrBound$]="flight | finToObservable"
            [services$]="currentServices$ | finMap: flight.id"
            [includedServices$]="currentIncludedServices$"
            [combinedServices$]="currentCombinedServices$"
            [availability$]="boundOrFlightAncillaryAvailability$"
            [initialSelectedTravelerId$]="initialSelectedTravelerId$"
            (subtotalChange)="ancillarySubview.setSubTotalPrice($event, currentCategory, flight.id)"
          ></fin-common-product-selection>
        </ng-container>
      </div>
    </ng-template>
  </ng-container>
</fin-ancillary-subview>

<fin-ancillary-sidebar
  *ngIf="(selectedCategory$ | async) !== Category.COVER"
  [category$]="selectedCategory$"
  [isSideBarOpen]="sideBarOpen$ | async"
  [boundsOrFlights$]="boundsOrFlights$"
  [locations]="(order$ | async).locations"
  [passengers]="(order$ | async).passengers"
  [purchasedServices$]="purchasedServices$"
  [availability$]="boundOrFlightAncillaryAvailability$"
  [showFareFamily]="false"
  [subTotalPrice$]="subTotalPrice$"
  [maxedOutForFragment$]="maxedOutForFragmentId$"
  (changeSelectedIndex)="showSubview(selectedCategory$.value, $event)"
  (ctaSideBarClosed)="closeSidebar()"
  (sideBarClosed)="closeSidebar()"
>
</fin-ancillary-sidebar>

<fcom-cta-button
  data-testid="manage-booking-ancillaries-cta-button"
  *ngIf="hasUnpaidServices$ | async"
  [title]="'actions.next' | finLocalization"
  [position]="ButtonPosition.GRID_TWO_THIRDS_RIGHT"
  [disabled]="priceUpdating$ | async"
  [visible]="true"
  (buttonClicked)="continuePurchase()"
  class="ctaButton z1"
>
  <span class="gray-50-text">{{ 'price.continueButtonTotal' | finLocalization }}: </span>
  <span class="font-body-1">{{ totalPrice$ | async | finPrice | finEmpty: '&ndash;' }}</span>
  <fcom-icon
    *ngIf="priceUpdating$ | async"
    class="ms-xsmall-l icon-medium loading-icon"
    [attr.aria-label]="'ctaButton.loading' | finLocalization"
    [name]="SvgLibraryIcon.TRANSFER_LOADER"
  ></fcom-icon>
</fcom-cta-button>
